import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import roleChooserReducer from './roleChooser/roleChooser.reducer';
import estateReducer from '../estates/estates.reducer';
import organisationReducer from '../organisations/organisations.reducer';
import configReducer from './config/config.reducer';

export const appStore = configureStore({
    reducer: {
        auth: authReducer,
        role: roleChooserReducer,
        estate: estateReducer,
        organisation: organisationReducer,
        config: configReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false //TODO: This is a workaround. Need to figure out why state entries are non-serializable. 
    })
});

export type AppStore = typeof appStore;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];